import React from "react";
import "./Navbar.scss";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="app__navbar">
      <ul>
        <li>
          <NavLink to="/tablette/index.html">Naolib</NavLink>
        </li>
        <li>
          <NavLink to="/tablette/carto">Carte</NavLink>
        </li>
        <li>
          <NavLink to="/tablette/eservices2">eServices</NavLink>
        </li>

        <li>
          <NavLink to="/tablette/applitan">Appli Tan - mTickets</NavLink>
        </li>
        <li>
          <NavLink to="/tablette/tanentreprises">Naolib Pro</NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
